module.exports = __webpack_public_path__ + "static/media/power.e7ce8b5a.png";